import * as React from "react";
import {
    Button,
    FormGroup,
    Label,
    Input,
    CustomInput,
    Row,
    Col
} from "reactstrap";
import { connect } from "react-redux";
import Header from "./Header";
import { MultipleChoiceForm } from "./MultipleChoiceForm";
import { Choice } from "../../models/choice";
import { FormStep, Step } from "../../store/application/applicationState";
import { ApplicationAction, setRKI, gotoStep, setContactInformation } from "../../store/application/applicationActions";
import ApplicationContent from "../applicationContent";
import ApplicationFooter from "../applicationFooter";
import { trackEvent } from "../../util/gtm";
import { RootState } from "../../store";


type Props = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

interface State {
    show: boolean;
    //name?: string;
    //mobile?: string;
    //email?: string;
    //loanAmount?: number;
    
   
}
class Rki extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            show: false,
            //name: props.application.data.name,
            //mobile: props.application.data.mobile,
            //email: props.application.data.email,
            //loanAmount: props.application.data.loanAmount,
        };

        
    }
    hasRKI(): void {
        this.setState({ show: true });
        var buttons = document.getElementsByClassName("choice");
        var yesbutton = buttons[0];
        yesbutton.classList.add("buttonDenied")
    }

    private choices: Array<Choice<boolean>> = [
        new Choice<boolean>("Ja", true, () => { this.hasRKI() }),
        new Choice<boolean>("Nej", false, () => { this.props.sethasRKI(false) })
    ]

     uuidEmit = () => {
        // Get now time
        const n = Date.now();
        // Generate random
        const r = Math.random();
        // Stringify now time and generate additional random number
        const s = String(n) + String(~~(r * 9e4) + 1e4);
        // Form UUID and return it
        return `${s.slice(0, 8)}-${s.slice(8, 12)}-4${s.slice(12, 15)}-${[8, 9, 'a', 'b'][~~(r * 3)]}${s.slice(15, 18)}-${s.slice(s.length - 12)}`;
    };
   
    render() {
        var params = window.location.search.toString();
        var regex = /((&|\?)step=)[0-9]{1,2}/gi;
        if (params != "") {
                params = params.replace(regex, "$1" + "4");
        }
        var stepQuery = window.location.protocol + "//" + window.location.host + window.location.pathname + params;
        console.log(stepQuery);
        window.history.pushState({ path: stepQuery }, '', stepQuery)
        return (
            <div>
                <Header formStep={FormStep.Other} step={Step.RKI} />
                <ApplicationContent>
                    <MultipleChoiceForm
                        title="Er du registreret i RKI?"
                        paragraph=""
                        choices={this.choices}
                    />
                    {this.state.show && <div className="hasRKI"><p>Vi kan desværre ikke tilbyde dig et lån, hvis du er registreret i RKI eller Debitor Registeret. Vi kan i stedet henvise dig til vores samarbejdspartner som kan hjælpe dig</p>

                        <a className="" target="_blank" href={'https://online.adservicemedia.dk/cgi-bin/click.pl?bid=1486365&media_id=88219&deeplink=%26FullName='
                            + this.props.application.data.name + '%26email=' + this.props.application.data.email + '%26telephone=' + this.props.application.data.mobile + '%26LoanAmout=' + this.props.application.data.loanAmount + '%26LoanTerm=' + this.props.application.data.repaymentPeriod
                            + "sub=" + this.uuidEmit()}>
                            <Button className="tando-btn" id="tando-btn" onClick={() => trackEvent("RKIalternativ", "Clickout", "Cashper")} >
                                Gå til Cashper
                               <img src="./images/white_next.svg"/>
                            </Button>

                        </a>
                    </div>}
                </ApplicationContent>
                <ApplicationFooter>
                    <Row className="mt-2">
                        <Col className="col-12 text-right">
                            <Button className="back" onClick={() => this.props.previous()}>
                                Tilbage
              </Button>
                        </Col>
                    </Row>
                </ApplicationFooter>
            </div>
        );
    }
}

//const mapDispatchToProps = (dispatch: (action: ApplicationAction) => void) => ({
//    setIsMarried: (isMarried: boolean) => {
//        dispatch(setMarried(isMarried));
//        trackEvent(
//            "Civilstatus",
//            isMarried ? "Gift" : "Ugift",
//            "Brugeren's civilstatus",
//            isMarried ? "Gift" : "Ugift"
//        )
//    }
//});

const mapStateToProps = (state: RootState) => ({
    application: state.applicationState
});



const mapDispatchToProps = (dispatch: (action: ApplicationAction) => void) => ({

    previous: () => dispatch(gotoStep(Step.Contact)),
    sethasRKI: (hasRKI: boolean) => {
        dispatch(setRKI(hasRKI));
        trackEvent(
            "RKI",
            hasRKI ? "Ja" : "Nej",
            "Brugeren's cRKI status",
            hasRKI ? "Ja" : "Nej"
        )
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Rki);
